import { FiSearch } from "react-icons/fi";

export default function SearchInput({ value, onChange, placeholder = "Search", label = "Search" }) {
  return (
    <label className="search-input">
      <FiSearch size={16} aria-hidden="true" />
      <input type="search" value={value} placeholder={placeholder} aria-label={label} onChange={(e) => onChange(e.target.value)} />
    </label>
  );
}
